module.exports = __webpack_public_path__ + "img/suguilong-2.6b3a872b.jpg";